import React from 'react'

export default function IndustrySector({data}) {
  return (
    <>
      <section className="industry-sector-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <span className="heading">{data.head}</span>
              <p>{data.overview}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
